import {
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableRow,
    Box, IconButton, Stack
} from "@mui/material";
import {useTranslation} from "react-i18next";
import {PAGE_APPLICATIONS} from "../../../locales/pages/namespaces";
import Tooltip from "@mui/material/Tooltip";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import SendIcon from "@mui/icons-material/SendOutlined";
const UploadedFilesTable = ({ files,onDelete,onSend }) => {
    const { t } = useTranslation(PAGE_APPLICATIONS);
    if (!files.length) return null;

    return (
        <Box mt={4}>
            <Table>
                <TableHead>
                    <TableRow>
                        <TableCell>{t('File Name')}</TableCell>
                        <TableCell>{t('Date - Hour')}</TableCell>
                        <TableCell align="center">{t("Actions")}</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {files.map((file, i) => (
                        <TableRow key={i}>
                            <TableCell>{file.name}</TableCell>
                            <TableCell>
                                {new Date(file.lastModified).toLocaleString()}
                            </TableCell>
                            <TableCell align="center">
                                <Stack direction="row" spacing={1} justifyContent="center">
                                    <Tooltip title={t("Send")}>
                                        <IconButton
                                            color="primary"
                                            onClick={() => onSend(file)}
                                        >
                                            <SendIcon />
                                        </IconButton>
                                    </Tooltip>

                                    <Tooltip title={t("Delete")}>
                                        <IconButton
                                            color="error"
                                            onClick={() => onDelete(i)}
                                        >
                                            <DeleteOutlineIcon />
                                        </IconButton>
                                    </Tooltip>
                                </Stack>
                            </TableCell>
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
        </Box>
    );
};

export default UploadedFilesTable;
